var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 48",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "thermometerTitle"
  }, "Thermometer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "thermometerTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 31.5v-26.5c0-2.8-2.2-5-5-5s-5 2.2-5 5v26.5c-2.7 1.8-4.2 4.8-4 8 0.3 4.6 4 8.2 8.6 8.5h0.4c5 0 9-4 9-9 0-3-1.5-5.8-4-7.5zm-0.2 12.6c-1.4 1.3-3.3 2-5.2 1.9-3.1-0.2-5.7-2.3-6.4-5.3s0.6-6.1 3.2-7.7l0.6-0.3v-27.7c0-1.7 1.3-3 3-3s3 1.3 3 3v27.7l0.5 0.3c2.2 1.2 3.5 3.6 3.5 6 0 1.9-0.8 3.8-2.2 5.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 36.2v-15.2h-2v15.2c-1.4 0.5-2.2 1.9-2 3.3 0.3 1.5 1.6 2.5 3 2.5s2.7-1.1 3-2.5c0.2-1.4-0.6-2.8-2-3.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.a3e3f51e4f150193f682750ba4fad390.svg";
export { ForwardRef as ReactComponent };